import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment  from 'moment';


@Component({
  selector: 'app-books-issue-report',
  templateUrl: './books-issue-report.component.html',
  styleUrls: ['./books-issue-report.component.css']
})
export class BooksIssueReportComponent implements OnInit {
  Submitted:boolean= false;
  ClassList=[];
  SectionList=[];
  LibraryType=[];
  StudentBookIssueList=[];
  StaffBookIssueList=[];
  PersonTypeList=[];

  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    currentPage = 1;
     pageSize = 20;
    recordCount = 0;
    totalPages = 0;
    numberOfPages () {

        this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }

    nextPage  () {
        this.currentPage = this.currentPage + 1;

    }

    pageSizes  () {
        this.currentPage = 1;
        this.recordCount = 0;
        this.totalPages = 0;

    }


    BooksIssueReportModel = {
        FromDate:moment(new Date()).format("DD-MMM-YYYY"),
        ToDate:moment(new Date()).format("DD-MMM-YYYY"),
        ClassID: 0,
        SectionID: 0,
        AuthorName: '',
        Publication: '',       
        StudentNo: '',
        StaffIdentity: '',
        StatusID: 0,
        PersonTypeID: 0,
        Subject: '',
        Language: '',
        BookTransactionID: 0,
        BookID: 0,
        BookSerialNo: '',
        LibraryTypeID: 0,
        CurrentIndex: 0,
        PageSize: 50,
        OrderBy: 'LibraryType',
        Order: 'ASC',
        Print:'',
        PersonID:0,

    };

    ClearSearch  () {
       
        this.StudentBookIssueList = [];
        this.BooksIssueReportModel.AuthorName = '';
        this.BooksIssueReportModel.StatusID = 0;
        this.BooksIssueReportModel.BookSerialNo = '';
        this.BooksIssueReportModel.ClassID = 0;
        this.BooksIssueReportModel.PersonTypeID = 0;
        this.BooksIssueReportModel.FromDate = '';
        this.BooksIssueReportModel.StudentNo = '';
        this.BooksIssueReportModel.StaffIdentity = '';
        this.BooksIssueReportModel.ToDate = '';
        this.BooksIssueReportModel.SectionID = 0;
        this.BooksIssueReportModel.LibraryTypeID = 0;
        this.BooksIssueReportModel.Subject = '';
        this.BooksIssueReportModel.Language = '';
        this.BooksIssueReportModel.Publication = '';
    }
    PrintReport  () {
        var ClassName = '';
        for (var i = 0; i < this.ClassList.length; i++) {
            if (this.ClassList[i].ItemId == this.BooksIssueReportModel.ClassID && this.BooksIssueReportModel.ClassID != 0) {
                ClassName = this.ClassList[i].ItemName;
                break;
            }
        }

        var SectionName = '';
        if (this.SectionList != null) {
            for (var i = 0; i < this.SectionList.length; i++) {
                if (this.SectionList[i].ItemId == this.BooksIssueReportModel.SectionID && this.BooksIssueReportModel.SectionID != 0) {
                    SectionName = this.SectionList[i].ItemName;
                    break;
                }
            }
        }
        var LibraryTypeName = '';
        if (this.LibraryType != null) {
            for (i = 0; i < this.LibraryType.length; i++) {
                if (this.LibraryType[i].ItemId == this.BooksIssueReportModel.LibraryTypeID && this.BooksIssueReportModel.LibraryTypeID != 0) {
                    LibraryTypeName = this.LibraryType[i].ItemName;
                    break;
                }
            }
        }

        var url = "../../../../App/Library/BooksIssueReport/BooksIssueReportPrint.html?PrintType=BooksIssueReport&FromDate=" + this.BooksIssueReportModel.FromDate + "&ToDate=" + this.BooksIssueReportModel.ToDate + "&AuthorName=" + this.BooksIssueReportModel.AuthorName + "&BookSerialNo=" + this.BooksIssueReportModel.BookSerialNo + "&ClassID=" + this.BooksIssueReportModel.ClassID + "&StudentNo=" + this.BooksIssueReportModel.StudentNo + "&SectionID=" + this.BooksIssueReportModel.SectionID + "&StaffIdentity=" + this.BooksIssueReportModel.StaffIdentity + "&StatusID=" + this.BooksIssueReportModel.StatusID + "&ClassName=" + ClassName + "&SectionName=" + SectionName + "&PersonTypeID=" + this.BooksIssueReportModel.PersonTypeID + "&LibraryTypeID=" + this.BooksIssueReportModel.LibraryTypeID + "&LibraryType=" + LibraryTypeName + "&Subject=" + this.BooksIssueReportModel.Subject + "&Language=" + this.BooksIssueReportModel.Language + "&Publication=" + this.BooksIssueReportModel.Publication;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    };
     ValidityState() {
        return this.BooksIssueReportModel.PersonTypeID == 0;
    }
    SearchBookIssueReport  () {
       
        this.StudentBookIssueList = [];
        this.Submitted = true;
        if (!this.ValidityState()) {
            
            this.BooksIssueReportModel.CurrentIndex = this.currentPage;
            this.BooksIssueReportModel.PageSize = this.pageSize;
            this.Submitted = false;
            this.spinnerService.show();
            this.BooksIssueReportModel.FromDate =this.BooksIssueReportModel.FromDate!=null && this.BooksIssueReportModel.FromDate!=''?moment(this.BooksIssueReportModel.FromDate).format('DD-MMM-YYYY'):'';
            this.BooksIssueReportModel.ToDate =this.BooksIssueReportModel.ToDate!=null && this.BooksIssueReportModel.ToDate!=''?moment(this.BooksIssueReportModel.ToDate).format('DD-MMM-YYYY'):'';
          
            this.libraryservice.SerchBooksIssueReturnDetail(JSON.stringify(this.BooksIssueReportModel)).subscribe( (response:any)=> {
                this.StudentBookIssueList = response.StudentBookIssueList;
                this.recordCount = 0;
                if (this.StudentBookIssueList != null && response.StudentBookIssueList.length > 0) {
                    this.recordCount = this.StudentBookIssueList[0].RecordCount;

                }
                this.numberOfPages();
                this.StaffBookIssueList = response.StaffBookIssueList;              
                this.globalHelper.CheckActionStatus(response);
                this.spinnerService.hide();
            });
        }
    };

    FilePath:''
    XLSDownload () {
    
        this.BooksIssueReportModel.Print = 'XLS';
        this.BooksIssueReportModel.CurrentIndex = 0;
        this.BooksIssueReportModel.PageSize = 0;
       this.spinnerService.show();
        this.libraryservice.SerchBooksIssueReturnDetail(JSON.stringify(this.BooksIssueReportModel)).subscribe( (data:any)=> {
            this.FilePath = data.FilePath;
            window.location = data.FilePath;
           
               this.spinnerService.hide();
                
            
        });
    };


    GetClass  () {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('Class', '').subscribe( (data:any)=> {
            this.ClassList = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetPersonType  () {
      this.spinnerService.show();
        this.lookupservice.GetLookupsList('PersonType', '').subscribe( (data:any)=> {
            this.PersonTypeList = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetSection () {
        this.BooksIssueReportModel.SectionID = 0;
        this.BooksIssueReportModel.PersonID = 0;
        this.spinnerService.show();
        var itemBo = {
            'ItemId': this.BooksIssueReportModel.ClassID,

        };
        this.lookupservice.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe( (data:any)=> {
            this.SectionList = data.LookupItems;
          this.spinnerService.hide();
        });

    };

    GetAllLibrary  () {
      this.spinnerService.show();
        this.lookupservice.GetLookupsList('LibraryType', '').subscribe( (data:any)=> {
            this.LibraryType = data.LookupItems;
            this.spinnerService.hide();
        });
    };

  ngOnInit() {
    this.GetPersonType();
    this.GetClass();
    this.GetAllLibrary();
  }

}
